import type { Account } from '@mattoespresso/brew-firestore';

import { doc, getDoc } from 'firebase/firestore';

import { FIRESTORE } from '../firebase';

export async function getAccount(userId: string): Promise<Account | null> {
  try {
    const accountRef = doc(FIRESTORE, 'account', userId);
    const accountSnap = await getDoc(accountRef);

    if (accountSnap.exists()) {
      return accountSnap.data() as Account;
    }
  } catch (error) {
    console.error(error);
  }

  return null;
}
